import {
  TBusinessFormData,
  TCategoryFormData,
  TChangePasswordFormData,
  TEmployeeFormData,
  TEventFormData,
  TGroupFormData,
  THistoryFormData,
  TMainVisualFormData,
  TMaterialsFormData,
  TNewsFormData,
  TNoticeFormData,
  TPartnerFormData,
  TPopupFormData,
  TRecruitFormData,
  TSettingsField,
} from 'src/@types';

export const INIT_POPUP_FORM_DATA: TPopupFormData = {
  title: '',
  descript: '',
  langCd: '',
  useYn: false,
  delYn: false,
  startDt: 0,
  endDt: 0,
  width: 0,
  height: 0,
  popupEnvCd: '',
  inactiveTime: 0,
  topPosition: null,
  leftPosition: null,
};

// 직원 관리 폼 초기 데이터
export const INIT_EMPLOYEE_FORM_DATA: TEmployeeFormData = {
  oprtrSid: 0,
  loginId: '',
  oprtrNm: '',
  oprtrGroupSid: 0,
  oprtrGroupSidList: [], // 그룹 ID 정보
  oprtrGroupList: [], // 그룹 정보
  oprtrSttsCd: 10602, // 계정상태: 정상(10601), 비활성(10602), 잠금(10603)
  beforePwd: '',
  pwd: '',
  pwdCorrect: '',
  regDt: 0,
  updDt: 0,
};

// 공지사항 관리 폼 초기 데이터
export const INIT_NOTICE_FORM_DATA: TNoticeFormData = {
  noticeSid: 0,
  prNotiCtgyCd: '',
  title: '',
  descript: '',
  filePath: [],
  deleteFilesPath: [],
  regDt: 0,
  updDt: 0,
};

// 뉴스 관리 폼 초기 데이터
export const INIT_NEWS_FORM_DATA: TNewsFormData = {
  newsSid: 0,
  prNewsCtgyCd: '',
  source: '',
  title: '',
  link: '',
  descript: '',
  filePath: [],
  deleteFilesPath: [],
  regDt: 0,
  updDt: 0,
  originRegDt: 0,
};
// 채용 지원 관리 폼 초기 데이터
export const INIT_RECRUIT_FORM_DATA: TRecruitFormData = {
  recruitSid: 0,
  expCd: 0,
  applyFieldCd: 0,
  veteranCd: 0,
  disabledCd: 0,
  nameKr: '',
  nameEn: '',
  desiredSalary: 0,
  genderTypeCd: 0,
  email: '',
  phone: '',
  emergencyContact: '',
  birthDate: '',
  calendarTypeCd: 0,
  applySrc: '',
  address: '',
  resumeFilePath: [],
  applyDt: 0,
  // recruitStatusCd: null,
  recruitStatusCd: '',
  memo: '',
};

export const INIT_MAIN_VISUAL_FORM_DATA: TMainVisualFormData = {
  visualSid: 0,
  mainText: '',
  subText: '',
  mainTextColor: '#000',
  subTextColor: '#000',
  bgPath: [],
  useYn: true,
  ordr: 0,
  deleteFilesPath: [],
  langCd: '',
};
export const INIT_HISTORY_FORM_DATA: THistoryFormData = {
  historySid: 0,
  historyDate: '',
  applyStDay: '',
  titleKo: '',
  titleEn: '',
  descript: '',
  useYn: false,
};
export const INIT_PARTNER_FORM_DATA: TPartnerFormData = {
  ordr: null,
  logoImgPath: null,
  partnerCtgyCd: '',
  partnerName: '',
  partnerSid: 0,
  useYn: true,
};
export const INIT_EVENT_FORM_DATA: TEventFormData = {
  eventTypeCd: '',
  startDt: '',
  location: '',
  title: '',
  descript: '',
  useYn: true,
};
export const INIT_MATERIAL_FORM_DATA: TMaterialsFormData = {
  materialSid: 0,
  title: '',
  files: [],
  filePath: [],
  useYn: true,
  delYn: false,
  langCd: '',
};
export const INIT_CATEGORY_FORM_DATA: TCategoryFormData = {
  categoryPsid: 0,
  categorySid: 0,
  useYn: true,
  ordr: 0,
  categoryInfoList: [],
  thumbnailPath: '',
  ctgyDpTypeCd: '',
};
export const INIT_BUSINESS_FORM_DATA: TBusinessFormData = {
  categorySid: '',
  pipelineSid: '',
  useYn: true,
  langCd: '',
  ordr: 0,
  title: '',
  link: '',
  summary: '',
  desktopImgPath: [],
  mobileImgPath: [],
  descript: '',
  businessSubList: [],
  thumbPath: null,
};

export const INIT_SETTINGS_FORM_DATA: TSettingsField = {
  langCd: '',
  companyNm: '',
  descript: '',
  link: null,
  address: null,
  tel: null,
  fax: null,
  email: null,
  copyright: null,
  salesInquiry: null,
  recruitmentInquiry: null,
  privacyPolicy: null,
  terms: null,
  logoImgFile: null,
  locationImgFile: null,
  companyIntroFile: null,
};

export const INIT_GROUP_FORM_DATA: TGroupFormData = {
  oprtrGroupNm: '',
  dscrpt: '',
  roleIdList: ['ADMIN'],
  useYn: true,
};

export const INIT_CHANGE_PASSWORD_DATA: TChangePasswordFormData = {
  currentPwd: '',
  pwd: '',
  pwdCorrect: '',
};
